import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import cx from 'classnames';
import translate from '../../../../commonComponents/translate';
import journeyProp from '../../propTypes/journeyProp';
import ToggleIcon from '../../../shared/icons/ToggleIcon';
import RewardJourneyCard from '../content/components/RewardJourneyCard';
import RewardJourneyCertificateCard from '../content/components/RewardJourneyCertificateCard';
import { useSanitize } from '../../../../services/customHooks';

function JourneyOverallRewards({ t, journey }) {
  const { description: journeyDescription, motivation, progress } = journey;
  const description = useSanitize(journeyDescription);
  const [isCollapsed, setIsCollapsed] = useState(!!progress);
  const toggleCollapsed = () => setIsCollapsed(prev => !prev);

  useEffect(() => setIsCollapsed(!!progress), [journey._id]);

  const showRewards =
    journey?.reward?.certificate?.enabled ||
    journey?.reward?.coins ||
    journey?.reward?.userType ||
    journey?.reward?.coupon ||
    journey?.reward?.couponDiscount ||
    journey?.reward?.chatGroup ||
    journey?.reward?.competenciesDomains;

  return (
    <div className="course-more-information journey-toggle-section">
      <h2>{t('journey_about')}</h2>
      <div
        className={cx('course-info-extra', {
          collapsed: isCollapsed,
        })}
      >
        <div className="row description-motivation-section">
          <div className="col-lg-12 description-wrapper">
            <div className="description-title">{t('description')}</div>
            {description && (
              <div
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
                style={{ marginTop: '2rem' }}
              />
            )}
          </div>
          <div className="col-lg-12 motivation-wrapper">
            {motivation && (
              <div className="course-more-information-right-info motivation-container">
                <div className="motivation-title">{t('journey_why')}</div>
                <p className="motivation-content">
                  <Linkify>{motivation}</Linkify>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={cx('academy-course-features journey-rewards', {
          collapsed: isCollapsed,
        })}
      >
        {showRewards && (
          <>
            <h2>{t('academy.rewards.journey')}</h2>
            <div className="rewards-wrapper">
              {journey?.reward &&
                journey?.reward?.certificate &&
                journey?.reward?.certificate?.enabled && (
                  <div className="certificate-container">
                    <RewardJourneyCertificateCard />
                  </div>
                )}
              <div
                className="rewards-container"
                style={{
                  width: !journey?.reward?.certificate?.enabled
                    ? '100%'
                    : '80%',
                }}
              >
                {journey?.reward?.coins && (
                  <RewardJourneyCard type="coins" reward={journey?.reward} />
                )}
                {journey?.reward?.coupon && (
                  <RewardJourneyCard
                    type="coupon"
                    reward={journey?.reward}
                    isFinished={journey?.progress === 100}
                  />
                )}
                {journey?.reward?.couponDiscount?.existentCouponId && (
                  <RewardJourneyCard
                    type="couponDiscount"
                    reward={journey?.reward}
                  />
                )}
                {journey?.reward?.userType && (
                  <RewardJourneyCard type="userType" reward={journey?.reward} />
                )}
                {journey?.reward?.userLevel && (
                  <RewardJourneyCard
                    type="userLevel"
                    reward={journey?.reward}
                  />
                )}
                {journey?.reward?.chatGroup && (
                  <RewardJourneyCard
                    type="chatGroup"
                    reward={journey?.reward}
                  />
                )}
                {journey?.reward?.isTrainer && (
                  <RewardJourneyCard
                    type="isTrainer"
                    reward={journey?.reward}
                  />
                )}
                {journey?.reward?.isOperator && (
                  <RewardJourneyCard
                    type="isOperator"
                    reward={journey?.reward}
                  />
                )}
                {journey?.reward?.competenciesDomains?.length > 0 && (
                  <RewardJourneyCard
                    type="competenciesDomains"
                    reward={journey?.reward}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <span
        className={cx('academy-course-arrow-toggle', {
          collapsed: isCollapsed,
        })}
        onClick={toggleCollapsed}
      >
        <ToggleIcon />
      </span>
    </div>
  );
}

JourneyOverallRewards.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(journeyProp.propType).isRequired,
};

export default translate(JourneyOverallRewards);
